// THIS FILE IS GENERATED, DO NOT MODIFY MANUALLY. ##checksum##: 1591216232
import { createAction } from 'typesafe-actions';

export const setManageFinancesWithPartner = createAction(
  'ONBOARDING/SET_MANAGE_FINANCES_WITH_PARTNER',
)<boolean>();

export const setTemporaryPromoCode = createAction('ONBOARDING/SET_TEMPORARY_PROMO_CODE')<string>();
